<template>
  <b-container>
    <b-row class="my-4">
      <b-col class="col-left">
        <b-form>
          <b-form-group
            id="test-type-name-group"
            label="Name"
            label-for="test-type-name-input"
          >
            <template v-slot:label>
              Name
              <span
                class="text-danger"
              >*
              </span>
            </template>
            <b-form-input
              id="test-type-name-input"
              v-model="input.name"
            />
          </b-form-group>
          <b-form-group
            id="test-type-abbreviation-label"
            label="Abbreviation"
            label-for="test-type-abbreviation-input"
            description="ไม่จำเป็น"
          >
            <b-form-input
              id="test-type-abbreviation-input"
              v-model="input.abbreviation"
            />
          </b-form-group>
          <template v-if="type === 'edit'">
            <div />
          </template>
          <div>
            <b-button
              variant="success"
              block
              @click="submitHandler"
            >
              {{ type === 'create' ? 'สร้าง' : 'บันทึก' }}
            </b-button>
            <template v-if="type === 'edit'">
              <b-button
                variant="danger"
                block
                @click="deleteHandler"
              >
                ลบประเภทตรวจ
              </b-button>
            </template>
          </div>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: "TestTypeDetail",
    props: {
      type: {
        type: String,
        default: 'create'
      },
      value: {
        type: Object,
        default: () => null
      }
    },
    data() {
      return {
        input: {
          name: null,
          abbreviation: null
        }
      }
    },
    computed: {
      typeString() {
        return this.type === 'create' ? 'สร้าง' : 'แก้ไข'
      }
    },
    watch: {
      value(value) {
        this.assignInput(value)
      }
    },
    mounted() {
      this.assignInput(this.value)
    },
    methods: {
      assignInput(value) {
        if (value) {
          this.input = value
        } else {
          this.input = {
            name: null,
            abbreviation:  null,
          }
        }
      },
      async submitHandler() {
        if (!this.input.name) {
         await this.$swal.fire('เกิดข้อผิดพลาด', 'กรุณากรอกข้อมูลชื่อประเภท', 'error');
         return
        }

        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.$emit('submit', { payload: this.input, id: this.input.id, password })
        } else {
          return
        }

      },
      async deleteHandler() {
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.$emit('delete', password)
        } else {
          return
        }

      }
    }
  }
</script>

<style scoped>

</style>